var exports = {
  "e4": "visualContainer__pMR50x",
  "dS": "clearOfClose__Cr-Sxz",
  "Cv": "visualImage__tJyP_v",
  "FK": "belowLarge__oEVemo",
  "nD": "mobileOnly__MNonMb",
  "Dw": "waveIn__8qfopV",
  "ly": "slideIn__mm_rzV",
  "J0": "flipIn__MbNBj_",
  "qG": "fadeIn___ZyYJK",
  "zm": "tabletOnly__iy8UX5",
  "DL": "largeUp__n1EozU",
  "WR": "desktopUp__mH526S",
};

module.exports = exports;
